import React, { useRef } from "react";
import { DEFAULT_BANNER_IMG, DEFAULT_BANNER_IMG_2 } from "../../conf";
import { BRAND_CLICK_TARGET } from "../../event_conf";
import { eventTypes } from "../../hooks/useTrack";
import useCachedViewTrack, {
	TRACKED_TARGET,
} from "../../hooks/useCachedViewTrack";
import brandEventPropertyMapper from "../../utils/brandEventPropertyMapper";
import useExperience from "../../hooks/useExperience";
import useImpression from "../../hooks/useImpression";
import {
	SNOWPLOW_EVENT,
	SNOWPLOW_SCHEMA_DATA_KEY,
} from "../../utils/snowplowEventMigrator";
import useElementInView from "../../hooks/useElementInView";
import LeadGenV1Brand from "./LeadGenV1Brand";
import LeadGenV0Brand from "./LeadGenV0Brand";

import "./lead-gen-brand.css"; // TODO: Isolate styles across v1 & v0 down the line once working on v1 again
import "./lead-gen-product.css";
import brandOfferEntityMapper from "../../utils/brandOfferEntityMapper";
import useLeadGenV0Config from "../../hooks/useLeadGenV0Config";

export const generateIncentiveImgUrl = ({ bannerUrl = "", logoUrl } = {}) => {
	if (
		bannerUrl &&
		bannerUrl !== DEFAULT_BANNER_IMG &&
		bannerUrl !== DEFAULT_BANNER_IMG_2
	) {
		return { url: bannerUrl, isLogoUrl: false };
	}

	return {
		url: logoUrl,
		isLogoUrl: true,
	};
};

const LeadGenBrand = ({
	className = "",
	brand,
	idx = -1,
	activeIdx,
	isOfferClaimed = false,

	claimOffer,
	claimedOffers,
	...rest
}) => {
	const { isLargeWidget } = useLeadGenV0Config();
	const MAX_BRAND_LOGO_IMG_SIZE = isLargeWidget ? 48 : 40;
	const isBrandActive = idx === activeIdx;
	const { id: brandId } = brand || {};

	const brandContainerRef = useRef(null);

	const defaultEventProps = brandEventPropertyMapper({
		brand,
		idx,
		feedHasUpsell: false,
	});

	const { isPartiallyInView } = useElementInView({
		elementRef: brandContainerRef,
	});

	useCachedViewTrack({
		id: brandId,
		key: TRACKED_TARGET.BRAND,
		event: eventTypes.WIDGET_BRAND_DISPLAY,
		properties: {
			...defaultEventProps,
			[SNOWPLOW_SCHEMA_DATA_KEY]: brandOfferEntityMapper({ brand }),
			initiatingTarget: BRAND_CLICK_TARGET.INLINE_COVER_TILE,
		},
		canTrack: isBrandActive && isPartiallyInView,
	});

	useImpression({
		id: brandId,
		cacheKey: TRACKED_TARGET.VIEWABLE_THRESHOLD_BRAND,
		event: SNOWPLOW_EVENT.WIDGET_VIEWABLE_THRESHOLD_BRAND_DISPLAY,
		properties: {
			...defaultEventProps,
			[SNOWPLOW_SCHEMA_DATA_KEY]: brandOfferEntityMapper({ brand }),
			initiatingTarget: BRAND_CLICK_TARGET.INLINE_COVER_TILE,
		},
		target: brandContainerRef.current,
	});

	const defaultComponentProps = {
		className,
		brand,
		idx,
		isOfferClaimed,
		MAX_BRAND_LOGO_IMG_SIZE,
		isBrandActive,
		defaultEventProps,
		brandContainerRef,

		claimOffer,
		claimedOffers,
		...rest,
	};

	const { isNurtureV1 } = useExperience();

	if (isNurtureV1) {
		return <LeadGenV1Brand {...defaultComponentProps} />;
	}

	return <LeadGenV0Brand {...defaultComponentProps} />;
};

export default LeadGenBrand;
